import React from 'react'
import { FaLinkedinSquare, FaGithub } from 'react-icons/lib/fa'
// https://gorangajic.github.io/react-icons/fa.html

const SocialLinks = () => (
  <ul className="social">
    <li>
      <a
        href="https://www.linkedin.com/in/williambirtwell/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaLinkedinSquare />
      </a>
    </li>
    {/* <li> */}
    {/*   <a href="https://github.com/brtw" target="_blank" rel="noopener noreferrer"> */}
    {/*     <FaGithub /> */}
    {/*   </a> */}
    {/* </li> */}
  </ul>
)

export default SocialLinks



// WEBPACK FOOTER //
// ./src/components/SocialLinks.js